// Types
export enum EventActions {
  PageLoad = 'page_load',
  Selection = 'selection',
  Click = 'click',
  Saved = 'saved',
}

export enum GAEventNames {
  Business = 'business',
  Contact = 'contact',
  Policy = 'policy',
  GeneralInformation = 'general_information',
  GeneralLiability = 'general_liability',
  Property = 'property',
  Review = 'review',
  Success = 'success',
  // PolicyStream specific events
  Welcome = 'welcome',
  BaseInformation = 'base_information',
  Personalize = 'personalize',
  Recommendations = 'recommendations',
  EmailSave = 'email_save',
  PlanSelection = 'plan_selection',
  PostPlanSelectionInformation = 'post_plan_selection_information',
  ContactInfo = 'contact_info',
  PlanSpecificQuestions = 'plan_specific_questions',
  Done = 'done',
  Resume = 'resume',
  Tos = 'tos',
  Demo = 'demo',
}

export enum Products {
  // Home = 'home',
  // Auto = 'auto',
  // Tenant = 'tenant',
  // Travel = 'travel',
  Commercial = 'commercial',
  Life = 'life',
}

export enum Environments {
  Development = 'development',
  Production = 'production',
}

export type GoogleAnalyticsEvent = {
  action: EventActions;
  sponsorCode?: string;
  description: string;
  product: Products;
  environment: string;
};
